<template>
  <donut-chart-card
    title="종사자 현황"
    :value="data"
    unit="명"
    :isMoveWrite="isMoveWrite"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import CircleGraphUtil from '@/util/CircleGraphUtil'
export default {
  name: 'DonutChart02',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    }
  },
  watch: {
    dataType (value) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 2,
      boardId: 553,
      summaryKey: this.dataType === 'company' ? '종사자현황_구분' : '종사자현황_부서',
      data: [{label: 'label', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      const yyyy = new Date().getFullYear()
      const projectId = this.$route.params.proj_id
      const boardId = 553 //state_government
      const page = 1
      const perPage = 10000
      let newList = []

      // newList
      if (this.isApproval) {

      } else {
        const dateBegin = `${yyyy}-01-01`
        const dateEnd = `${yyyy}-12-31`
        await this.$store.dispatch('board/LOAD_POST_LIST', {
          projectId: projectId ? projectId : 1,
          boardId,
          page,
          perPage,
          dateTarget: 'created_at',
          dateBegin, dateEnd,
        })
        newList = this.convertListData(this.$store.state.board.postListInfo.data)
      }

      const value = []
      const _temps = Object.keys(newList)
      for (const _temp of _temps) {
        const contents = newList[_temp].summary[this.summaryKey]
        for (const content of contents) {
          const key = Object.keys(content)[0]
          value.push({
            label: key,
            value: Number(`${content[key]}`)
          })
        }
      }

      // value = {key: value, key2: value}
      // CircleGraphUtil.getColumnFromEachCompany(value, summaryKey1)
      // [{label: '', value: 0},{label: '', value: 0}]
      this.data = value
    },

    convertListData (list) {
      // 데이터 변형하기,
      // 매달 마지막에 작성 글을 기준으로 변경하기,
      const temp = {}
      for (const data of list) {
        const date = new Date(data.created_at).format('yyyy-MM-01')
        if (data.post_content) {
          temp[date] = JSON.parse(data.post_content)
        }
      }
      return temp;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
